module.exports = __webpack_public_path__ + "img/warning-logo.6d219532.png";